import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import { StatusSignal } from '../../Helpers/deviceStatusMap';
import Typography from '@mui/material/Typography';

const ActionCard = ({ actionImage, actionDescription, status }) => {

  return (
    <Box width="50vh">
      <Card>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {actionImage && (
            <Box sx={{ 
              width: 120, 
              height: 120,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2
            }}>
              {typeof actionImage === 'string' && actionImage.startsWith('fa ') ? (
                <i className={actionImage} style={{ fontSize: '60px' }} />
              ) : (
                <img 
                  src={actionImage} 
                  alt={actionDescription} 
                  style={{ 
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }} 
                />
              )}
            </Box>
          )}

          {actionDescription && (
            <Typography variant="h6" align="center">
              {actionDescription}
            </Typography>
          )}
          
          <Box sx={{ 
            width: 38, 
            height: 38,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {status === 'gateway' ? (
              <img 
                src={require('../DataMap/assets/gatewayicon.png')} 
                alt="Gateway" 
                style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
              />
            ) : (
              <StatusSignal status={status} />
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ActionCard;